import * as React from 'react';
import { Toolbar, Switch, FormControlLabel, Button, Box } from '@mui/material';
import { Brightness4, Brightness7, Business, Add } from '@mui/icons-material';
import { useAppSelector, useAppDispatch } from '../../store';
import { setTheme } from '../../store/slices/appSlice';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
    StyledRoot,
    StyledAppBar,
    StyledTitle,
    StyledThemeToggle,
    StyledContainer,
} from './Layout.styles';
import LogoutIcon from '@mui/icons-material/Logout';
import { useToast } from '../../providers/ToastContext';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<any> = () => {
    const dispatch = useAppDispatch();
    const theme = useAppSelector(state => state.app.theme);
    const navigate = useNavigate();
    const location = useLocation();
    const { showToast } = useToast();

    const handleThemeChange = () => {
        dispatch(setTheme(theme === 'light' ? 'dark' : 'light'));
    };
    const handleLogout = () => {
        showToast('Logout successfully!', 'success');
        navigate('/login');
    };
    const isActive = (path: string) => location.pathname === path;

    return (
        <StyledRoot>
            <StyledAppBar position="static">
                <Toolbar>
                    <StyledTitle variant="h6" component="div">
                        SimplyPay Frontend
                    </StyledTitle>
                    <Box
                        sx={{
                            flexGrow: 1,
                            display: 'flex',
                            gap: 2,
                            marginLeft: 4,
                        }}
                    >
                        <Button
                            color="inherit"
                            startIcon={<Business />}
                            onClick={() => navigate('/merchants')}
                            variant={
                                isActive('/merchants') || isActive('/')
                                    ? 'outlined'
                                    : 'text'
                            }
                        >
                            Merchants
                        </Button>
                        <Button
                            color="inherit"
                            startIcon={<Add />}
                            onClick={() => navigate('/merchant/create')}
                            variant={
                                isActive('/merchant/create')
                                    ? 'outlined'
                                    : 'text'
                            }
                        >
                            Create Merchant
                        </Button>
                    </Box>
                    <StyledThemeToggle>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={theme === 'dark'}
                                    onChange={handleThemeChange}
                                    icon={<Brightness7 />}
                                    checkedIcon={<Brightness4 />}
                                />
                            }
                            label=""
                        />
                    </StyledThemeToggle>
                    <Button
                        color="inherit"
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        sx={{ marginLeft: 2 }}
                    >
                        Logout
                    </Button>
                </Toolbar>
            </StyledAppBar>
            <StyledContainer maxWidth="xl">
                <Outlet />
            </StyledContainer>
        </StyledRoot>
    );
};

export default Layout;
